__turbopack_context__.v({
  "badge": "puppySearchResults-module-scss-module__9I9TIa__badge",
  "badgeStack": "puppySearchResults-module-scss-module__9I9TIa__badgeStack",
  "description": "puppySearchResults-module-scss-module__9I9TIa__description",
  "emptyListingState": "puppySearchResults-module-scss-module__9I9TIa__emptyListingState",
  "emptyState": "puppySearchResults-module-scss-module__9I9TIa__emptyState",
  "errorBanner": "puppySearchResults-module-scss-module__9I9TIa__errorBanner",
  "eyebrow": "puppySearchResults-module-scss-module__9I9TIa__eyebrow",
  "heading": "puppySearchResults-module-scss-module__9I9TIa__heading",
  "listingItem": "puppySearchResults-module-scss-module__9I9TIa__listingItem",
  "listingMeta": "puppySearchResults-module-scss-module__9I9TIa__listingMeta",
  "listingTitle": "puppySearchResults-module-scss-module__9I9TIa__listingTitle",
  "listings": "puppySearchResults-module-scss-module__9I9TIa__listings",
  "loadMoreRow": "puppySearchResults-module-scss-module__9I9TIa__loadMoreRow",
  "paginationMeta": "puppySearchResults-module-scss-module__9I9TIa__paginationMeta",
  "providerCard": "puppySearchResults-module-scss-module__9I9TIa__providerCard",
  "providerCardSelected": "puppySearchResults-module-scss-module__9I9TIa__providerCardSelected",
  "providerEyebrow": "puppySearchResults-module-scss-module__9I9TIa__providerEyebrow",
  "providerHeader": "puppySearchResults-module-scss-module__9I9TIa__providerHeader",
  "providerLocation": "puppySearchResults-module-scss-module__9I9TIa__providerLocation",
  "providerName": "puppySearchResults-module-scss-module__9I9TIa__providerName",
  "providersList": "puppySearchResults-module-scss-module__9I9TIa__providersList",
  "resultsHeader": "puppySearchResults-module-scss-module__9I9TIa__resultsHeader",
  "resultsSection": "puppySearchResults-module-scss-module__9I9TIa__resultsSection",
  "sectionLabel": "puppySearchResults-module-scss-module__9I9TIa__sectionLabel",
  "statusPill": "puppySearchResults-module-scss-module__9I9TIa__statusPill",
  "tile": "puppySearchResults-module-scss-module__9I9TIa__tile",
  "tileGrid": "puppySearchResults-module-scss-module__9I9TIa__tileGrid",
});
